import { z } from "zod";

export const banUserSchema = z.object({
	reason: z.string().trim().max(500).optional(),
});
export type BanUserPayload = z.infer<typeof banUserSchema>;

export const ACCOUNT_BANNED_ERROR_CODE = "account_banned" as const;

export const banStatusResponseSchema = z.object({
	banned: z.boolean(),
	banned_at: z.union([z.date(), z.string()]).nullable(),
	banned_reason: z.string().nullable(),
});
export type BanStatusResponse = z.infer<typeof banStatusResponseSchema>;
